var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ height: _vm.viewportHeight }),attrs:{"id":"app"}},[_c('miniProgramCode'),_c('keep-alive',{attrs:{"include":['toolbar', 'editIndex']}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }